<template>
  <div>
    <div class="specification-wrapper">
      <input-textarea
        id="features"
        :value="forms.productDetail.feature"
        placeholder="List the features of this product"
        label="Features"
        @change="(val) => $emit('handleChangeInput', 'productDetail.feature', val)"
        :error="(errors && errors.productDetail && errors.productDetail.feature) || null"
        :disabled="!!catalogId"
      />
      <br>
      <input-text
        label="Color Technology"
        placeholder="Specify the color technology used in this product"
        id="productionYear"
        :value="forms.productDetail.colorTech"
        @change="(val) => $emit('handleChangeInput', 'productDetail.colorTech', val)"
        :error="(errors && errors.productDetail && errors.productDetail.colorTech) || null"
        :disabled="!!catalogId"
      />
    </div>
  </div>
</template>

<script>
import {
  SingleSelect,
  InputText,
  InputTextarea,
  InputRadio,
} from "../../../Input";

export default {
  name: "Printer",
  components: {
    SingleSelect,
    InputText,
    InputTextarea,
    InputRadio,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    forms: {
      type: Object,
      required: true,
    },
  },
  computed: {
    catalogId() {
      const id = Number(this.$route.params.id)
      return isNaN(id) ? 0 : id;
    }
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 700;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
}

.section-description {
  font-weight: 400;
  font-size: 0.875rem;
}

.specification-wrapper {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 0.5rem;
}

.bg-white {
  background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/TechSpec/Printer.vue